import React from 'react';

const LoadingButton = ({
  disabled,
  isLoading,
  title,
  children: Component,
  icon,
  ...rest
}) => {
  const className = isLoading ? "fas fa-spinner fa-spin" : icon;
  return (
    <Component
      disabled={disabled || isLoading}
      {...rest}
    >
      <span>
        <i className={className} /> {title}
      </span>
    </Component>
  );
  
}

export default LoadingButton;
